import { render, staticRenderFns } from "./boxHead.vue?vue&type=template&id=714883ee&scoped=true&"
import script from "./boxHead.vue?vue&type=script&lang=js&"
export * from "./boxHead.vue?vue&type=script&lang=js&"
import style0 from "./boxHead.vue?vue&type=style&index=0&id=714883ee&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "714883ee",
  null
  
)

export default component.exports